import './style.scss';
import React from 'react';
import { GrFormPreviousLink, GrFormNextLink } from 'react-icons/gr';
import useContentNavigationBtn from 'pctHooks/useContentNavigationBtn';

import { makeStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';



type Props = {
    collection: BlockElement | any;
    text: string;
    direction: string;
    unlockNext: boolean;
    numberRequest: number;
    userIsAdmin: boolean;
    hasRequestedUpgrade?: boolean;
    isUpgradeButtonActive?: boolean;
};

const useTooltipStyles = makeStyles(() => ({
    tooltip: {
        fontSize: '10px !important',
        padding: '4px 10px',
        lineHeight: 1,
        maxWidth: '160px',
        textAlign: 'center',
    },
    arrow: {
        fontSize: '8px',
    },
}));

const ContentNavigationBtn = ({
    collection,
    text = '',
    direction,
    unlockNext = false,
    numberRequest = 0,
    userIsAdmin = false,
    hasRequestedUpgrade = false,
    isUpgradeButtonActive = false,
}: Props) => {

    const tooltipClasses = useTooltipStyles();


    const { handMouseNextPrevEvent, hasNextSequential } = useContentNavigationBtn({
        collection,
        direction,
        unlockNext,
        numberRequest,
        userIsAdmin,
        hasRequestedUpgrade,
        isUpgradeButtonActive,
    });

    
    return (
        <div className="contentNavBtn">
            {direction === 'prev' && (
                <Tooltip
                    title={
                        !collection?.previousItem?.allowed ? 'Conteúdo anterior bloqueado' : 'Veja o conteúdo anterior'
                    }
                    aria-label={'Veja o conteúdo anterior'}
                    placement="top"
                    classes={tooltipClasses}
                    disableHoverListener={!collection.previousItem}
                >
                    <button
                        className={`prevContentBtn ${!collection.previousItem ? 'disabled' : ''} ${
                            !collection?.previousItem?.allowed ? 'blocked' : ''
                        }`}
                        onClick={(e) => {
                            if (collection.previousItem && 
                                collection?.previousItem?.allowed){
                                handMouseNextPrevEvent(e);
                            } else {
                                e.stopPropagation();
                            }
                        }}
                    >
                        <GrFormPreviousLink />
                        {/* <Text text={text} component={'small'} /> */}
                    </button>
                </Tooltip>
            )}

            {direction === 'next' && (
                <Tooltip
                    title={hasNextSequential() ? 'Próximo conteúdo bloqueado' : 'Veja o próximo conteúdo'}
                    aria-label={'Veja o próximo conteúdo'}
                    placement="top"
                    classes={tooltipClasses}
                    disableHoverListener={!collection.nextItem}
                >
                    <button
                        className={`nextContentBtn ${!collection.nextItem ? 'disabled' : ''} ${
                            hasNextSequential() ? 'blocked' : ''
                        }`}
                        onClick={(e) => {
                            if (collection.nextItem && !hasNextSequential()) {
                                handMouseNextPrevEvent(e)
                            }else{
                                e.stopPropagation();
                            };
                        }}
                    >
                        {/* <Text text={text} component={'small'} /> */}
                        <GrFormNextLink />
                    </button>
                </Tooltip>
            )}
        </div>
    );
};

export default ContentNavigationBtn;
